import { useEffect, useState } from "react";
import React from 'react';
import Api from "../../Api/Api";
import { username } from "../../API";

import NavBar from "../Navbar";

const PrivacyPolicy = () => {
  const [user, setUser] = useState(null);
  const [configData, setConfigData] = useState(false);
  // const { username } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getConfigText(username);
      console.log(data);
      for (let i = 0; i < data?.length; i++) {
        if (data[i].title === "Privacy Policy") {
          setConfigData(data[i]);
        }
      }
    };
    getData();
  }, [username]);

  // console.log(JSON.parse(JSON.stringify(configData?.Text)));

  return (
    <>
      <NavBar />
      <div className="container bg-light min-vh-100 rounded mb-3 mt-5" >
        <div className="mt-t ms-3 ">

          <h2 className="pt-3 text-center">Privacy Policy</h2>
          <div className="pb-4 mt-3" dangerouslySetInnerHTML={{ __html: configData?.Text }}></div>
        </div>
      </div>
    </>
  );
};
export default PrivacyPolicy;
